/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unreachable */
/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import convertToCurrency from '../../helpers/convertToCurrency';
import useListenSize from '../../hooks/useListenSize';
import useApi from '../../hooks/useApi';
import { segmentEvent } from '../../helpers/sendEvent';
import calculatePeriod from '../../helpers/calculatePeriod';
import { addPayFrequency, addCheckoutAll, addPayFrequencyLookup, addIsAonFlow } from '../../redux/actions';
import { DisplayOfferedLeaseDetailsB } from './DisplayOfferedLeaseDetailsB';
import fullStoryOfferPageInit from '../../helpers/fullStoryOfferPage';
import {
  isKplusAvailable as checkKplusAvailable,
  isBoostAvailable as checkBoostAvailable,
} from '../../helpers/kplusPricing';

export function DisplayOfferedLeaseDetails() {
  const {
    handleSubmit,
    register,
    formState: { errors, isValid },
  } = useForm({ mode: 'onChange' });
  const history = useHistory();
  const dispatch = useDispatch();
  useListenSize();

  const { request, loading } = useApi();

  const store = useSelector(state => ({
    billingState: state?.loanInfo?.billingState,
    checkoutBillingState: state?.personal?.checkoutLookupData?.checkout_object?.customer?.shipping?.state,
    firstName: state?.personal?.firstName,
    confirmedLeaseAgreement: state?.loanInfo?.confirmedLeaseAgreement,
    confirmedPriceTagDisclosure: state?.loanInfo?.confirmedPriceTagDisclosure,
    checkout: state?.loanInfo?.checkout,
    payFrequency: state?.loanInfo?.payFrequency,
    promotion: state?.loanInfo?.promotion,
    shopify: state.technical?.shopify,
    featureGateLinearFlow: state.loanInfo?.featureGateLinearFlow,
    vwo: state.technical?.vwo?.decisions?.find(obj => obj.feature === 'offerPage')?.variation,
    vwoAll: state.technical?.vwo,
    offerPageFlow: state.technical?.offerPageFlow,
    featureGates: state.technical?.featureGates,
    userId: state.loanInfo?.userId,
    isAonFlow: state.loanInfo?.isAonFlow,
  }));

  const checkoutData = {
    totalOrder: store?.checkout?.cart_total,
    purchaseAmount: store?.checkout?.cart_total,
    dueToday: store?.checkout?.due_today,
    duePeriodPayment: store?.checkout?.monthly_total,
    costOfOwnership: store?.checkout?.full_term_cost,
    discount: true,
    payFrequency: store.payFrequency,
    frequency: {
      paymentsNumber: store?.checkout?.num_cycles,
      monthsNumber: store?.checkout?.term,
    },
    dueTodayDetails: {
      initialPayment: store?.checkout?.initial_payment,
      processingFee: store?.checkout?.processing_fee,
      shipping: store?.checkout?.shipping,
      nonLesableItems: store?.checkout?.non_leasable_item_amount,
      tax: store?.checkout?.tax_due_checkout,
      total: store?.checkout?.due_today,
      duePeriodPayment: store?.checkout?.monthly_total,
      pay_frequency: store.payFrequency,
    },
    earlyPurchase: {
      total90: store?.checkout?.total_90,
      tax90: store?.checkout?.tax_90,
    },
  };

  const hasRbpFees = store?.checkout?.rbp_first_fee != null && store?.checkout?.rbp_base_fee != null;
  const rbpFirstFee = Number.parseFloat(store?.checkout?.rbp_first_fee);
  const rbpBaseFee = Number.parseFloat(store?.checkout?.rbp_base_fee);
  const isRbpPromo = hasRbpFees && rbpFirstFee < rbpBaseFee;
  const isPromoExist = store.promotion?.discount?.amount_off;
  const giftCardValue = Number.parseFloat(store?.checkout?.rbp_giftcard_value);
  const hasGiftCardPromo = !Number.isNaN(giftCardValue) && giftCardValue > 0;
  const vofSavingAmount = isRbpPromo ? Math.floor(rbpBaseFee - rbpFirstFee) : 0;
  const isKplusAvailable = checkKplusAvailable(store?.checkout);
  const kplusMonthlyPrice = isKplusAvailable ? convertToCurrency(store.checkout.kplus_monthly_amount).trim() : '';

  const isBoostAvailable = checkBoostAvailable(store?.checkout);
  // Eligibility alone isn't enough to offer Boost: a customer already enrolled
  // shouldn't see it pitched again as an add-on. isAonFlow is set by the
  // enrollment-check effect below, once we know which case we're in.
  const showBoostOption = isBoostAvailable && Boolean(store.isAonFlow);

  // eslint-disable-next-line consistent-return
  const getPeriod = () => {
    return calculatePeriod(store?.checkout?.num_cycles, store?.checkout?.term);
  };

  useEffect(() => {
    if (!store.payFrequency) {
      addPayFrequency(getPeriod());
    }
    segmentEvent('page', 'Offer', {
      lease_payment: store?.checkout?.monthly_total,
      pay_frequency: getPeriod() || store.payFrequency,
    });

    if (isPromoExist) {
      setTimeout(() => {
        segmentEvent('track', 'Discount Viewed', {
          page: 'Review Page',
          discount_type: 'promotion',
          discount_amount: store.promotion?.discount?.amount_off / 100,
          discount_retailer_name: 'Wayfair',
          discount_minimum_cart_amount: null,
          discount_promo_code: store.promotion?.id,
        });
      }, 1000);
    }
  }, []);

  useEffect(() => {
    const sendCheckoutRequest = async () => {
      if (store.offerPageFlow?.isOfferPageFlow) {
        const payload = { uid: store.offerPageFlow?.uid };
        const checkoutRequest = await request.checkoutRequest(payload);
        dispatch(addPayFrequencyLookup({ first_name: checkoutRequest.first_name, payfrequency_exists: true }));
        dispatch(addCheckoutAll(checkoutRequest));
        fullStoryOfferPageInit({
          partnerName: checkoutRequest?.retailer_name,
          firstName: checkoutRequest?.first_name,
          customerPhone: checkoutRequest?.customer_phone,
          uid: store.offerPageFlow?.uid,
        });
      }
    };
    setTimeout(() => {
      sendCheckoutRequest();
    }, 100);
  }, []);

  useEffect(() => {
    const checkAonEnrollment = async () => {
      if (!isBoostAvailable || !store.userId) return;
      const enrollmentStatus = await request.getAonEnrollmentStatus(store.userId);
      const isNotYetEnrolled = enrollmentStatus?.aon_enrolled === false && enrollmentStatus?.status === 'none';
      dispatch(addIsAonFlow(isNotYetEnrolled));
    };
    checkAonEnrollment();
    // request is excluded on purpose: useApi() hands back a fresh, unmemoized
    // object every render, so listing it would refire this check (and its
    // dispatch) on every re-render instead of only when eligibility changes.
  }, [isBoostAvailable, store.userId, store.checkout]);

  const cartAmount = () => {
    if (!isPromoExist) {
      return (
        <tr>
          <td>Cart amount</td>
          <td>{convertToCurrency(store?.checkout?.cart_total)}</td>
        </tr>
      );
    }
    const promotionAmount = store.promotion?.discount?.amount_off / 100;

    return (
      <>
        <tr>
          <td>Initial cart amount</td>
          <td>{convertToCurrency(store?.checkout?.cart_total)}</td>
        </tr>
        <tr className="k-brand-text">
          <td>Katapult Promotion</td>
          <td>-{convertToCurrency(promotionAmount)}</td>
        </tr>
        <tr style={{ fontWeight: 'bold' }}>
          <td>Final cart amount</td>
          <td>{convertToCurrency(store?.checkout?.cart_total - promotionAmount)}</td>
        </tr>
      </>
    );
  };

  const onSubmit = async () => {
    segmentEvent('track', 'Offer Submitted', {
      lease_payment: store?.checkout?.monthly_total,
      pay_frequency: getPeriod() || store.payFrequency,
    });

    history.push('/price-tag-disclosures');
  };

  const compenentData = {
    store,
    cartAmount,
    getPeriod,
    checkoutData,
    isPromoExist,
    handleSubmit,
    onSubmit,
    history,
    register,
    errors,
    isValid,
    loading,
    isRbpPromo,
    hasGiftCardPromo,
    giftCardAmountDisplay: `$${Math.round(giftCardValue).toLocaleString('en-US')}`,
    isKplusAvailable,
    kplusMonthlyPrice,
    isBoostAvailable: showBoostOption,
    vofSavingAmount,
  };

  return (
    <>
      <DisplayOfferedLeaseDetailsB {...compenentData} />
    </>
  );
}
